module.exports = __webpack_public_path__ + "static/media/c-more-max.2cc8ee3e.png";